import { EABFilterImplementationType, type FilterOption } from "@/graphql";
import type { EventFilter } from "../FilterTypes";
import QuickSearchFilterBadge from "../ui/badges/QuickSearchFilterBadge.vue";

export default class QuickSearchFilter implements EventFilter {
  constructor(
    public readonly searchText: string,
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = QuickSearchFilterBadge;

  getEventFilter(): FilterOption | undefined {
    const searchText = this.searchText.trim();
    if (searchText === "") {
      return undefined;
    }
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_ACTION_FREE_TEXT,
        value: {
          value: searchText,
          negated: this.isNegated ?? false,
        },
      },
    };
  }
}
